// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__2JKwb","dadosUsuario":"OptionSelect_dadosUsuario__iH-B6","focado":"OptionSelect_focado__3-Udx"};